<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="요금제 관리" device="web" :IsUseSearchRequirement="true">
        <template v-slot:SearchRequirement>
          <v-row no-gutters>
            <v-col class="d-flex justify-space-between align-center">
              <v-switch v-model="feeUseYn">
                <template v-slot:label>
                  <span style="margin-left: 5px;">{{ feeUseYn ? "사용" : "미사용" }}</span>
                </template>
              </v-switch>
            </v-col>
          </v-row>
        </template>

        <template v-slot:body>
          <DxDataGrid
            id="feeDataGrid"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :selection="{ mode: 'single' }"
            key-expr="id"
            :focused-row-enabled="true"
            @editing-start="onEditingStart"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing :allow-updating="true" mode="batch" :select-text-on-edit-start="true" />
            <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />
            <DxColumn
              data-field="feeCd"
              data-type="string"
              width="180px"
              alignment="center"
              caption="요금제 코드"
              :allow-editing="false"
            />

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="feeType"
              data-type="string"
              width="100px"
              alignment="center"
              caption="구분"
            >
              <DxLookup :data-source="feeTypeDiv" display-expr="minorNm" value-expr="minorCd" />
            </DxColumn>

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="feeSubType"
              data-type="string"
              alignment="center"
              caption="상세구분"
            >
              <DxLookup :data-source="feeSubTypeDiv" display-expr="minorNm" value-expr="minorCd" />
            </DxColumn>

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="feeName"
              data-type="string"
              alignment="center"
              caption="요금제 명"
            />

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="constructAmount"
              data-type="string"
              alignment="center"
              caption="기준 공사 금액(<)"
              cell-template="calcKorWon"
            />

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="feeAmount"
              width="110px"
              data-type="string"
              alignment="center"
              caption="요금"
              cell-template="calcKorWon"
            />

            <DxColumn
              data-field="useYn"
              data-type="boolean"
              width="90px"
              caption="사용"
              alignment="center"
              edit-cell-template="checkBoxEditor"
              :allow-editing="true"
            />

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="ordSeq"
              data-type="int"
              width="90px"
              alignment="center"
              caption="순서"
              :allow-editing="true"
            />

            <DxColumn
              data-field="feeExplanation"
              data-type="string"
              width="180px"
              alignment="left"
              caption="요금제 설명"
              :allow-editing="true"
            />
            <DxColumn
              data-field="remark"
              data-type="string"
              width="200px"
              alignment="left"
              caption="비고"
              :allow-editing="true"
            />
            <template #calcKorWon="{ data: cellInfo }">
              <span>{{calcKorWon(cellInfo.value) + '원'}}</span>
            </template>

            <template #checkBoxEditor="{ data: cellInfo }">
              <DxCheckBox
                :value="cellInfo.value == 'Y' ? true : false"
                :onValueChanged="value => onCheckValueChanged(value, cellInfo)"
              />
            </template>
          </DxDataGrid>
        </template>
      </i-card-vertical>
      <i-card-right
        headerTitle
        :useBtnList="buttonUseList"
        @btnSearch="btnSearch(true)"
        @btnAdd="btnAdd()"
        @btnSave="btnSave()"
      ></i-card-right>
    </v-sheet>
  </v-container>
</template>
  
<script>
import iCardVertical from '@/components/common/iCardVertical.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'

import { getFeeList, saveFeeData } from '@/api/feeManage/feeManage.js'
import { getCommonCode } from '@/api/common/commonApi'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'feeManage',
  components: {
    'i-card-vertical': iCardVertical
  },
  data() {
    return {
      dxDataGridRef: 'feeGridRef',
      gridMain: [],
      allowEditingColList: ['useYn', 'ordSeq', 'feeExplanation', 'remark'], // 수정이 허용되는 컬럼 리스트
      feeUseYn: true,
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave' // 저장
      ],
      feeTypeDiv: [], // 요금제 구분
      feeSubTypeDiv: [] // 고객 회원가입 구분
    }
  },
  activated() {},
  watch: {
    feeUseYn() {
      this.btnSearch(true)
    }
  },
  computed: {},
  beforeMount() {},
  created() {
    // 요금제 구분 조회
    getCommonCode('FEE001').then(res => {
      if (res.success) this.feeTypeDiv = res.list
    })
    // 고객 회원가입 구분
    getCommonCode('CP001').then(res => {
      if (res.success) this.feeSubTypeDiv = res.list
    })
  },
  mounted() {
    this.btnSearch(true)
  },
  methods: {
    //------------------------------------------
    //  버튼 이벤트
    //------------------------------------------
    btnSearch(notify = false) {
      let params = {
        clntId: this.getClntId(),
        useYn: this.feeUseYn ? 'Y' : 'N'
      }
      this.openLoading()
      getFeeList(params, notify)
        .then(res => {
          if (res.success) {
            this.gridMain = res.list
            if (res.list.length > 0) this.GetDataGrid(this.dxDataGridRef).clearSelection()
          }
        })
        .catch(err => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnAdd() {
      let newRow = {
        id: (this.gridMain.length + '_' + new Date().getSeconds() + new Date().getMilliseconds()).toString(),
        feeCd: '',
        feeType: '',
        feeSubType: '',
        feeName: '',
        constructAmount: '',
        feeAmount: '',
        useYn: 'Y',
        ordSeq: 0,
        feeExplanation: '',
        remark: '',
        __created__: true
      }
      this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
    },
    btnSave() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          console.log('@@ selectedRows', selectedRows)
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }
          this.GetDataGrid(this.dxDataGridRef).saveEditData()
          let valid = selectedRows.findIndex(el => !el.feeType || !el.feeSubType || !el.feeName || !el.constructAmount || !el.feeAmount)
          if (valid >= 0) {
            this.vToastify(this.$t('필수항목 입력하세요.'), 'info')
            return
          }
          let ordValid = selectedRows.findIndex(el => isNaN(el.ordSeq) || el.ordSeq < 0)
          if (ordValid >= 0) {
            this.vToastify(this.$t('순서는 숫자만 입력 가능합니다.'), 'info')
            return
          }
          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            async () => {
              // this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.openLoading('')
              try {
                saveFeeData(selectedRows, true).then(res => {
                  //
                  this.btnSearch()
                })
              } catch (error) {
                this.endLoading()
              } finally {
                this.endLoading()
              }
            },
            null,
            true
          )
        })
    },
    //------------------------------------------
    //  etc 이벤트
    //------------------------------------------
    calcKorWon(value) {
      const numberValue = parseFloat(value.replace(/,/g, ''))
      if (!isNaN(numberValue)) {
        return numberValue.toLocaleString('ko-KR')
      } else return 0
    },
    onEditingStart(e) {
      if (!e.data.__created__ && !this.allowEditingColList.includes(e.column.dataField)) {
        e.cancel = true
      }
    },
    onEditorPreparing(e) {
      // onCellValueChanged 를 사용하기 위함
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) valueChanged(args.value, e)
        }
      }
      if (e.parentType === 'dataRow' && !e.row.data.__created__ && e.column) {
        if (!this.allowEditingColList.includes(e.column.dataField)) {
          e.editorOptions.readOnly = true
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      if (cellInfo.dataField === 'constructAmount' || cellInfo.dataField === 'feeAmount') {
        // 특수문자 제거
        value = value.replace(/[^\w\s]/gi, '')
      }
      // if (!cellInfo.row.data.__created__) {
      //   this.vSnackbar(this.$t('기존 데이터일 경우 사용, 순서, 요금제 설명, 비고 항목만 수정이 가능합니다.'), 'warn', 3000)
      //   return
      // }
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
      // this.GetDataGrid(this.dxDataGridRef).saveEditData()
    },
    onCheckValueChanged(value, cellInfo) {
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
      // this.GetDataGrid(this.dxDataGridRef).saveEditData()
    }
  }
}
</script>
  
  <style scoped></style>
  